import React, { useEffect, useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PageHero } from '../components/PageHero';
import { Heart, CheckCircle2, ShieldCheck, ExternalLink } from 'lucide-react';
import { motion } from 'framer-motion';
const presetAmounts = [100, 200, 500, 1000];
export function DonatePage() {
  const [selectedAmount, setSelectedAmount] = useState<number | null>(500);
  const [customAmount, setCustomAmount] = useState<string>('');
  const [comment, setComment] = useState('');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleAmountClick = (amount: number) => {
    setSelectedAmount(amount);
    setCustomAmount('');
  };
  const handleCustomAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === '' || /^\d+$/.test(value)) {
      setCustomAmount(value);
      setSelectedAmount(null);
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const finalAmount = selectedAmount || Number(customAmount);
    if (!finalAmount) return;
    console.log('Donation submitted:', {
      amount: finalAmount,
      comment
    });
    alert(`Дякуємо! Перенаправлення на оплату ${finalAmount} ₴...`);
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-627">
      <Header data-id="element-628" />

      <main className="flex-grow pt-20 pb-24" data-id="element-629">
        <PageHero label="Допомога" title="Підтримати федерацію" subtitle="Ваш внесок допомагає нам розвивати гірські види спорту в Україні." data-id="element-630" />

        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mt-12" data-id="element-631">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden relative" data-id="element-632">
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-rose-400 rounded-l-2xl" data-id="element-633" />

            <div className="flex flex-col lg:flex-row" data-id="element-634">
              {/* Left Column: Content */}
              <div className="p-8 lg:p-12 lg:w-1/2 flex flex-col justify-center" data-id="element-635">
                <div className="flex items-start gap-4 mb-6" data-id="element-636">
                  <div className="w-12 h-12 rounded-full bg-rose-50 flex items-center justify-center flex-shrink-0" data-id="element-637">
                    <Heart className="h-6 w-6 text-rose-500" data-id="element-638" />
                  </div>
                  <div data-id="element-639">
                    <h2 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-640">
                      Підтримати федерацію
                    </h2>
                    <p className="text-sm text-gray-500" data-id="element-641">
                      Добровільний внесок · не впливає на статус членства
                    </p>
                  </div>
                </div>

                <p className="text-gray-600 leading-relaxed mb-8" data-id="element-642">
                  Ваш добровільний внесок допомагає розвивати альпінізм та
                  скелелазіння в Україні — організовувати змагання, навчальні
                  програми та підтримувати спортсменів. Кожна гривня важлива!
                </p>

                <div className="inline-flex items-center gap-2 px-4 py-2.5 bg-emerald-50 text-emerald-700 rounded-lg text-sm font-medium self-start" data-id="element-643">
                  <CheckCircle2 className="h-4 w-4" data-id="element-644" />
                  Всі внески офіційні та прозорі
                </div>
              </div>

              {/* Right Column: Form */}
              <div className="p-8 lg:p-12 lg:w-1/2 bg-slate-50/50 border-t lg:border-t-0 lg:border-l border-gray-100" data-id="element-645">
                <form onSubmit={handleSubmit} className="max-w-md mx-auto" data-id="element-646">
                  <h3 className="text-base font-bold text-gray-900 mb-4" data-id="element-647">
                    Оберіть або введіть суму
                  </h3>

                  {/* Preset Amounts */}
                  <div className="grid grid-cols-4 gap-3 mb-4" data-id="element-648">
                    {presetAmounts.map(amount => <button key={amount} type="button" onClick={() => handleAmountClick(amount)} className={`py-3 px-2 rounded-xl text-sm font-semibold border transition-all ${selectedAmount === amount ? 'border-rose-400 bg-rose-50 text-rose-600 shadow-sm' : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-50'}`} data-id="element-649">
                        ₴{amount}
                      </button>)}
                  </div>

                  {/* Custom Amount */}
                  <div className="relative mb-6" data-id="element-650">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-651">
                      <span className="text-gray-500 font-medium" data-id="element-652">₴</span>
                    </div>
                    <input type="text" value={customAmount} onChange={handleCustomAmountChange} placeholder="Інша сума" className={`w-full pl-8 pr-4 py-3.5 bg-white border rounded-xl text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-rose-400/20 ${customAmount ? 'border-rose-400 text-gray-900 font-medium' : 'border-gray-200 text-gray-900 hover:border-gray-300'}`} data-id="element-653" />
                  </div>

                  {/* Comment */}
                  <div className="mb-8" data-id="element-654">
                    <label htmlFor="comment" className="block text-xs text-gray-500 mb-2" data-id="element-655">
                      Коментар (необов'язково)
                    </label>
                    <input id="comment" type="text" value={comment} onChange={e => setComment(e.target.value)} placeholder="Наприклад: на організацію чемпіонату" className="w-full px-4 py-3.5 bg-white border border-gray-200 rounded-xl text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:border-rose-400 focus:ring-2 focus:ring-rose-400/20 transition-colors" data-id="element-656" />
                  </div>

                  {/* Submit Button */}
                  <button type="submit" disabled={!selectedAmount && !customAmount} className="w-full flex items-center justify-center gap-2 py-4 px-6 bg-[#E598A8] hover:bg-[#d68797] text-white rounded-xl font-semibold text-base transition-colors disabled:opacity-50 disabled:cursor-not-allowed shadow-sm" data-id="element-657">
                    <Heart className="h-5 w-5" data-id="element-658" />
                    Підтримати через LiqPay
                    <ExternalLink className="h-4 w-4 ml-1 opacity-80" data-id="element-659" />
                  </button>

                  {/* Security Note */}
                  <div className="mt-4 flex items-center justify-center gap-1.5 text-xs text-gray-400" data-id="element-660">
                    <ShieldCheck className="h-4 w-4" data-id="element-661" />
                    <span data-id="element-662">Безпечна оплата через LiqPay</span>
                  </div>
                </form>
              </div>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer data-id="element-663" />
    </div>;
}